import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {getQuerystring, getToken} from '../Common'


const UnuthenticatedUsersOnly = () => {
    return !getToken() ? <Outlet /> : <Navigate to={getQuerystring("redirect") || "/my-cases"} />
}

export default UnuthenticatedUsersOnly;